import { loadContent, validateChain, type Content } from './schema'
import { BUNDLED_CONTENT, STARTER_CHAIN } from './data'

export * from './schema'
export { BUNDLED_CONTENT, STARTER_CHAIN } from './data'

// Validate the bundled content once, at import time. A dangling reference
// throws here rather than surfacing later inside the sim. The starter chain is
// validated against that content at boot too — an unknown or mis-connected
// chain building fails here, not later inside createSimState.
export const CONTENT: Content = loadContent(BUNDLED_CONTENT)
validateChain(CONTENT, [...STARTER_CHAIN])
